<template>
  <tr class="related-content">
    <td :colspan="numberOfCols">
      <div
        class="vs-con-loading__container flex pb-10 mb-5 border-0 border-b border-solid border-grey-light"
        :id="id"
      >
        <vs-table-m
          :total="filesData ? filesData.count || 0 : 0"
          :data="filesData ? filesData.results || [] : []"
          class="mt-10 w-full"
          noDataText="No files in this course"
        >
        <template slot="header">
            <div class="flex items-center w-full">
              <h6 class="m-2 my-4">
                Files in this course
              </h6>
            </div>
            
          </template>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="name">Selected</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.name">{{ tr.name}}</vs-td>
              <vs-td :data="tr.id">
                <vs-button type="border" @click.stop="$emit('file-added', tr)">
                  <feather-icon
                    v-if="checkSelected(tr.id)"
                    icon="CheckIcon"
                    svgClasses='h-5 w-5 color-current text-blue'
                    class='flex items-center mx-3'
                  />
                  <span v-else>Select</span>
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table-m>
      </div>
    </td>
  </tr>
</template>
<script>
import uuid from 'uuid'
import VsTableM from '@/components/VsTableM'

export default {
  name: 'ContentFiles',
  components: {
    VsTableM,
  },
  props: {
    numberOfCols: {
      type: Number,
      required: true
    },
    filesData: Object,
    loading: Boolean,
    filesSelected: Array
  },
  data: () => {
    return {
      id: `u${uuid.v4()}`
    }
  },
  methods: {
    checkSelected (id) {
      if (this.filesSelected && this.filesSelected.length) {
        return this.filesSelected.includes(id)
      }
    },
  },
  mounted() {
    if (this.loading) {
      this.$vs.loading({
        container: `#${this.id}`,
        scale: 0.6
      })
    }
    
  },
  watch: {
    'loading': function (newValue) {
      if (newValue) {
        this.$vs.loading({
          container: `#${this.id}`,
          scale: 0.6
        })
      } else {
        this.$vs.loading.close(`#${this.id} > .con-vs-loading`)
      }
    }
  }
}
</script>